import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDvbYEHZARTzJ33N1GnBSf0LejdKxAulIU",
  authDomain: "shabbat-abroad.firebaseapp.com",
  projectId: "shabbat-abroad",
  storageBucket: "shabbat-abroad.appspot.com",
  messagingSenderId: "1076189420651",
  appId: "1:1076189420651:web:72dee9fef484f399dbe52e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services with error handling
let db, auth, storage, googleProvider;

try {
    db = getFirestore(app);
    auth = getAuth(app);
    storage = getStorage(app);
    googleProvider = new GoogleAuthProvider();
} catch (error) {
    console.error('Firebase initialization error:', error);
    // Fallback initialization
    db = getFirestore(app);
    auth = getAuth(app);
    storage = getStorage(app);
    googleProvider = new GoogleAuthProvider();
}

// Export initialized services
export { db, auth, storage, googleProvider }; 